import { all } from 'redux-saga/effects';
import Auth from './Auth';
import JewelleryCoinPrice from './JewelleryCoinPrice';
import MarkupDeductPercentage from './MarkupDeductPercentage';
import ActionHistory from './ActionHistory';
import FeedConfig from './FeedConfig';
import FeedPrice from './FeedPrice';
import Company from './Company';

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    JewelleryCoinPrice(),
    MarkupDeductPercentage(),
    ActionHistory(),
    FeedConfig(),
    FeedPrice(),
    Company(),
  ]);
}
